<template>
    <div class="form-floating select">
        <select ref="view" v-bind="$attrs" v-model="value" class="form-select-lg w-100 d-none" :class="state">
            <slot />
        </select>
        <slot name="error" />
    </div>
</template>

<script lang="ts">
import $ from 'jquery'
import { merge } from 'lodash'
//import "select2"
import Select2, * as select2 from 'select2'
import { Component, Emit, Model, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({
    emits: ['update:modelValue'],
    inheritAttrs: false,
})
class Select extends Vue {
    // eslint-disable-next-line no-undef
    select2!: any

    declare $attrs: {
        id?: string
        disabled?: any
        multiple?: any
    }

    @Model({ type: [String, Number, Array, Object] })
    value!: string | string[] | number

    @Ref('view')
    readonly view!: HTMLSelectElement

    @Prop({ type: Object })
    readonly options!: select2.Options

    @Prop({ type: String })
    readonly label!: string

    @Prop({ type: Object, default: () => [] })
    readonly errors!: []

    @Prop({ type: String, default: '' })
    readonly state!: string

    @Emit('update:modelValue')
    modelValueSelected(value: string | string[] | number) {
        return value
    }

    @Emit('data')
    onSelectedData() {
        return this.view.multiple ? this.select2.select2('data') : this.select2.select2('data')[0]
    }

    @Watch('modelValue', { deep: true, immediate: true })
    onSelectedChange(value: number | string | string[], oldValue?: number | string | string[]) {
        if (!this.select2) return

        if (value instanceof Array) {
            this.select2.val([...value])
        } else {
            this.select2.val(value)
        }
        if (value != oldValue) {
            this.select2.trigger('change.select2')
        }
        //this.value = value
        //this.modelValueSelected(value)
    }

    get defaults(): select2.Options {
        return {
            //@ts-ignore
            ajax: {
                method: 'GET',
                data: ({ term, page }) => {
                    return {
                        search: term,
                        page: page || 1,
                        number: 10,
                        offset: ((page || 1) - 1) * 10,
                    }
                },
                delay: 250,
                cache: !import.meta.env.VITE_APP_DEBUG, //true,
            },
            debug: import.meta.env.VITE_APP_DEBUG,
            theme: 'bootstrap-5',
            placeholder: this.label,
            //minimumResultsForSearch: Infinity,
            //@ts-ignore
            templateResult: ({ text }) => text,
            //@ts-ignore
            templateSelection: ({ text }) => text,
        }
    }

    created() {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                XDEBUG_SESSION: 'vsc',
            },
        })
    }

    mounted() {
        $(() => {
            //@ts-ignore
            Select2()
            let opts: select2.Options = merge(this.defaults, this.options)
            if (opts.ajax === null) {
                delete opts.templateSelection
                delete opts.templateResult
            }
            this.select2 = $(this.view).select2(opts)

            this.initialize(opts)

            this.select2.on('change.select2', () => {
                //console.log(this.select2.val())
                this.value = this.select2.val() //this.modelValueSelected(this.select2.val())
            })
            $('.select2-selection').addClass('d-flex flex-column justify-content-center')
            if (typeof opts.data === 'undefined') {
                //this.onSelectedChange(this.modelValue)
            }
        })
    }

    updated() {
        if (this.select2) {
            //@ts-ignore
            Select2()
            let opts: select2.Options = merge(this.defaults, this.options)
            if (opts.ajax === null) {
                delete opts.templateSelection
                delete opts.templateResult
            }
            this.select2 = $(this.view).select2(opts)
            this.select2.on('change.select2', () => {
                this.value = this.select2.val() //this.modelValueSelected(this.select2.val())
            })
            $('.select2-selection').addClass('d-flex flex-column justify-content-center')
            if (typeof opts.data === 'undefined') {
                //this.onSelectedChange(this.modelValue)
            }
        }
    }

    unmounted() {
        if (this.select2) this.select2.select2('destroy')
    }

    initialize(opts) {
        //console.log(this.value, opts.ajax)
        if (this.value && opts.ajax != null) {
                if (this.value instanceof Array) {
                    for (let value of this.value) {
                        this.createOption(value, value)
                    }
                    this.select2.val([...this.value])
                } else {
                    this.createOption(this.value, this.value)
                    this.select2.val(this.value)
                }
        }
    }

    createOption(text, id) {
        let option = new Option(text, id, false, true)
        this.select2.append(option)
    }
}

export interface SelectData {
    name: string
    value: string
}

export default toNative(Select)
</script>

<style lang="scss">
@import '@/scss/variables';
@import '@/theme/scss/main';
//@import '@/theme/scss/vendor/select2';
@import 'select2/src/scss/core';
@import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';
@import 'select2-bootstrap-5-theme/src/include-all';

.select2 {
    width: 100% !important;
}

.select2-selection {
    min-height: 56px !important;
}

// Dropdown panel
.select2-container--bootstrap-5 .select2-dropdown {
    border: 1.5px solid #e5e7eb !important;
    border-radius: 10px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
    margin-top: 4px !important;
    overflow: hidden !important;
    padding: 4px !important;
}

// Search field inside dropdown
.select2-container--bootstrap-5 .select2-search--dropdown {
    padding: 8px 8px 4px !important;

    .select2-search__field {
        border: 1.5px solid #e5e7eb !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        color: #374151 !important;
        background-color: #f9fafb !important;
        transition: border-color 0.15s, box-shadow 0.15s;

        &:focus {
            outline: none !important;
            border-color: $secondary !important;
            box-shadow: 0 0 0 3px rgba($secondary, 0.12) !important;
            background-color: #fff !important;
        }
    }
}

// Results list
.select2-container--bootstrap-5 .select2-results__options {
    padding: 4px !important;
    max-height: 240px !important;
    overflow-y: auto !important;
}

.select2-container--bootstrap-5 .select2-results__option {
    border-radius: 8px !important;
    padding: 10px 14px !important;
    font-size: 14px !important;
    color: #374151 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    transition: background-color 0.1s;

    &--highlighted:not(.select2-results__option--selected) {
        background-color: #f3f4f6 !important;
        color: #374151 !important;
    }

    &--selected {
        background-color: #f1f5f9 !important;
        color: #1e40af !important;
        font-weight: 500 !important;

        &::after {
            content: '';
            display: inline-block;
            width: 18px;
            height: 18px;
            flex-shrink: 0;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%231e40af' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 16px;
        }

        &.select2-results__option--highlighted {
            background-color: #e2e8f0 !important;
            color: #1e40af !important;
        }
    }

    &[aria-disabled='true'] {
        color: #9ca3af !important;
    }
}
</style>
